import { User } from 'lucide-react';

import { definePanel } from '@/app/definePanel';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'user_details',
    title: 'User',
    icon: User,
    // Mirrors the server settings — narrow-but-roomy detail panel.
    width: { min: 400, default: 480, max: 800, fill: false },
    modes: [PanelMode.Settings],
    themes: PanelTheme.Any,
    // The left-hand Users list remains visible first when space becomes tight.
    order: 3.8,
    // Auto-opens from the Users panel; no rail button.
    hasNavButton: false,
    // The users list opens it from its one view, so only the close of the list closes it.
    summoner: { id: 'users', props: [] },
    // userId lives in this panel's local props in localStorage (not URL-synced).
    urlSyncedProps: [],
});
